<template>
  <div>
    <div class="is-inline">
      <button
        class="button is-white has-text-primary"
        style="padding-right: 0"
        @click="subscribeToTopic"
      >
        <span class="icon" v-if="!$store.state.user.userDoc.subscriptions.includes(topic)">
          <i class="mdi mdi-plus mdi-24px"></i>
        </span>
        <span
          :class="{'has-text-grey': $store.state.user.userDoc.subscriptions.includes(topic)}"
          class="has-text-weight-medium"
        >{{ $store.state.user.userDoc.subscriptions.includes(topic) ? $t('ui.subscribed') : $t('ui.subscribe') | capitalize }}</span>
      </button>
    </div>

    <b-modal :active.sync="isSubscribeInfoModalActive">
      <div class="card" style="border-radius: 8px; margin: 0 24px">
        <div class="card-content py-1">
          <p
            class="has-text-centered"
          >Sevdiğin tarzlara abone olarak etkinlik bildirimleri alabilirsin.</p>
          <div class="is-flex mt-1" style="justify-content: space-between">
            <span
              @click="isSubscribeInfoModalActive = false"
              class="has-text-primary"
            >{{ $t('ui.notNow') }}</span>
            <span
              @click="getNotificationPermission"
              class="has-text-primary"
            >{{ $t('ui.permitNotifications') }}</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { messaging, fbFunctions } from "@/fireinit";

export default {
  props: {
    topic: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isSubscribeInfoModalActive: false
    };
  },

  methods: {
    async subscribeToTopic() {
      // get token if not request permission
      const isSubscribed = this.$store.state.user.userDoc.subscriptions.includes(this.topic)

      await this.$store.commit("user/ADD_TO_SUBSCRIPTIONS", this.topic);

      const token = await messaging.getToken();

      // TODO complete the function
      // if token then subscribe
      // save it to indexedDB or to vuex store (on background function)
      // save it to user doc if user is not anonymous (on background function)

      // if not token show info modal
      // then request permission

      console.log("messaging TOKEN", token);
      //   return;

      if (token) {
        if (!isSubscribed) {

          const subscribeToTopicFunc = fbFunctions.httpsCallable(
            "subscribeToTopic"
          );
          subscribeToTopicFunc({
            token,
            topic: this.$store.state.user.userCity + "_" + this.topic,
            userId: this.$store.state.user.authUser.uid
          })
            .then(res => {
              console.log("subscribeToTopicFunc", res);
            })
            .catch(err => {
              console.log("subscribeToTopicFunc", err);
            });
        } else {
          const unsubscribeToTopicFunc = fbFunctions.httpsCallable(
            "unsubscribeToTopic"
          );
          unsubscribeToTopicFunc({
            token,
            topic: this.topic,
            userId: this.$store.state.user.authUser.uid
          })
            .then(res => {
              console.log("unsubscribeToTopicFunc", res);
            })
            .catch(err => {
              console.log("unsubscribeToTopicFunc", err);
            });
        }
      } else {
        this.isSubscribeInfoModalActive = true;
      }
    },
    async getNotificationPermission() {
      messaging
        .requestPermission()
        .then(() => {
          console.log("Permission for subscribe is granted");
          return messaging.getToken();
        })
        .then(reqToken => {
          this.subscribeToTopic();
          this.isSubscribeInfoModalActive = false;
        })
        .catch(err => {
          console.log("Permission for subscribe is denied...");
        });
    }
  }
};
</script>

<style>
</style>